import { Button } from '@mui/material'
import { goToTreeManagementTool } from 'app/Routers'
import React from 'react'

export function ToolButton({
  toolId,
  treeId,
  versionId,
}: {
  toolId: string
  treeId: string
  versionId: string
}) {
  return (
    <Button
      onClick={() =>
        goToTreeManagementTool({
          treeId,
          versionId,
          toolId,
        })
      }
    >
      Go To {toolId} Tool
    </Button>
  )
}
